// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Tutorial_ReportUsersInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /tutorial/report_users
 *
 * Validates the optional slug filter query parameter.
 */
import { registerContract } from './validate'

export interface Tutorial_ReportUsersInput {
slug?: string
}

registerContract('Tutorial_ReportUsersInput', {
  slug: { type: 'string',  required: false },
})
